// import {useState, useEffect} from 'react';
import styles from './style.module.scss';
// import {faDownload} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  Button, GrayButton,
} from '@/components/common-components/v2/Button';
// import {CopyOutlined} from '@ant-design/icons';

import {Divider, Tooltip} from 'antd';
import {faCheck, faPlus} from '@fortawesome/pro-regular-svg-icons';
import {
  SCA_CREATE_PAGE,
  // SCA_PAGE_CONTENT_IDEA_COPY,
  // SCA_PAGE_AI_OUTLINE_DOWNLOAD
} from '@/constants/events';

import {MixPanel} from '@/utils/mixpanel';
// import {getLocalesByKey as t} from '@/utils/translation';
// import {useStore} from '@/store/root-store';
// import parse from 'html-react-parser';
// import {faArrowsRotate} from '@fortawesome/pro-solid-svg-icons';

import {useRouter} from 'next/router';
import {routes} from '@/utils/const';
import {CONTENT_ASSISTANT_API} from '@/api/ContentAssistant';
import {useStore} from '@/store/root-store';
import {AtomicBlockUtils, convertToRaw, EditorState} from 'draft-js';
import {faArrowUpRightFromSquare} from '@fortawesome/pro-duotone-svg-icons';

interface Props {
  aiOutline: any;
  insertToEditor: any;
  outlineId?: number;
  // rewriteOutline?: (value: string, idx: number) => any;
  // rewritingOutline?: boolean;
  // rewritingOutlineId?: number;
}

export const SingleAiOutline = ({
  aiOutline,
  insertToEditor,
  outlineId,
  // rewriteOutline,
  // rewritingOutline,
  // rewritingOutlineId
}: Props) => {
  // const [copySuccess, setCopySuccess] = useState(false);
  // const [textForInjection, setTextForInjection] = useState(null);

  //

  const router = useRouter();
  const {contentOptimizer: {aiOutline: {aiTemplatesController, setIsOpenAiContentToolsDrawer}}} = useStore('');


  // const downloadImage = async (url: string) => {
  //   const image = await fetch(url);
  //   const imageBlog = await image.blob();
  //   const imageURL = URL.createObjectURL(imageBlog);

  //   const link = document.createElement('a');
  //   link.href = imageURL;
  //   link.download = 'Generated art';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };


  const formatImageIntoBlock = (editorState, base64) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      'image',
      'IMMUTABLE',
      {src: base64},
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
  };

  const handleCreateContent = async () => {
    const pagePayload = {};
    pagePayload['title'] = aiOutline.heading ?? '';
    // eslint-disable-next-line
    const cleanedHtml = aiOutline ? `<p></p><NextImg src=\"${aiOutline}\" width=\"40%\" alt=\"img\" /><p></p>` : '';
    pagePayload['cleaned_html'] = cleanedHtml;
    const editorState = EditorState.createEmpty();
    const newEditorState = formatImageIntoBlock(editorState, aiOutline);
    const contentState = newEditorState.getCurrentContent();
    const rawJson = JSON.stringify(convertToRaw(contentState));
    pagePayload['editor_state'] = rawJson;

    const {uuid} = await CONTENT_ASSISTANT_API.createPage(pagePayload);

    MixPanel.track(SCA_CREATE_PAGE, {
      'pageId': uuid,
    });

    setIsOpenAiContentToolsDrawer(false);

    router.push(`/${routes.landingPageOptimizer}/${uuid}`, null, {shallow: true});
  };

  return (
    <div className={styles.ContentIdeaContainer}>
      <p className={styles.ContentIdea}>
        <img src={aiOutline} className={styles.ContentIdeaImage}/>
        {/* {convertedText} */}
        {/* {convertedText && parse(aiOutline)} */}

      </p>
      <div className={styles.ideaOrder}>{outlineId + 1}</div>
      <Divider className={styles.popoverDivider} />
      <div style={{display: 'flex', justifyContent: 'space-between', cursor: 'default'}}>

        <div className={styles.controlButtons}>
          {!aiTemplatesController?.isStandaloneTool ? <Button
            color={aiOutline?.isAdded ? 'green' : 'purple'}
            variant='ghost'
            className={styles.addToArticleBtn}
            onClick={() => {
              insertToEditor(aiOutline);
            }}>
            {aiOutline?.isAdded ? <span>
              <FontAwesomeIcon icon={faCheck} style={{marginRight: 10}}/>
                Added
            </span> :
              <span>
                <FontAwesomeIcon icon={faPlus} style={{marginRight: 10}}/>
                Add to article
              </span>}
          </Button> : null}

          {/* <Tooltip
            title={'Download'}
            trigger='hover'
            placement='bottom'
            overlayClassName={styles.copyTooltip}
          >
            <FontAwesomeIcon icon={faDownload} className={styles.downloadButton} onClick={() => {
              downloadImage(aiOutline);

              MixPanel.track(SCA_PAGE_AI_OUTLINE_DOWNLOAD, {
                'description': 'Content idea downloaded',
              });
            }} />
          </Tooltip> */}
          <Tooltip
            title={'Open image in new tab'}
            trigger='hover'
            placement='bottom'
            overlayClassName={styles.copyTooltip}
          >
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{marginLeft: 10}} className={styles.downloadButton} onClick={() => {
              window.open(aiOutline, '_blank');
            }}
            />
          </Tooltip>
          {aiTemplatesController?.isStandaloneTool ?
            <GrayButton onClick={() => handleCreateContent()}>
              <FontAwesomeIcon icon={faPlus} style={{marginRight: 10}}/>
            Create article
            </GrayButton> :
            null}
        </div>
      </div>
    </div>
  );
};
